/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
// https://github.com/kirill-konshin/next-redux-wrapper/tree/types-enchancements/packages/demo-redux-toolkit

import { configureStore, ThunkAction } from '@reduxjs/toolkit'
import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { nextReduxCookieMiddleware, wrapMakeStore } from 'next-redux-cookie-wrapper'
import { createWrapper } from 'next-redux-wrapper'
import { Action } from 'redux'
import mainApi from '../services/mainAPI'
import athleteSlice from './athleteProfile'
import joinEventSlice from './joinevent'
import userSlice from './user'

export type MainAPIState = ReturnType<typeof mainApi.reducer>
export type JoinEventState = ReturnType<typeof joinEventSlice.reducer>
export type UserState = ReturnType<typeof userSlice.reducer>
export type AthleteState = ReturnType<typeof athleteSlice.reducer>

const makeStore = wrapMakeStore(() => {
    const store = configureStore({
        reducer: {
            [mainApi.reducerPath]: mainApi.reducer,
            [joinEventSlice.name]: joinEventSlice.reducer,
            [userSlice.name]: userSlice.reducer,
            [athleteSlice.name]: athleteSlice.reducer
        },
        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: (
            getDefaultMiddleware: CurriedGetDefaultMiddleware<{
                mainApi: MainAPIState
                [joinEventSlice.name]: JoinEventState
                [userSlice.name]: UserState
                [athleteSlice.name]: AthleteState
            }>
        ) =>
            getDefaultMiddleware()
                .prepend(
                    // TODO: create a cart reducer and only persist that
                    nextReduxCookieMiddleware({
                        subtrees: [
                            'user.data',
                            'athleteProfile.data',
                            'athleteProfile.user'
                        ]
                    })
                )
                .concat(mainApi.middleware),
        devTools: process.env.NODE_ENV !== 'production'
    })
    setupListeners(store.dispatch)

    return store
})

export type AppStore = ReturnType<typeof makeStore>
export type AppState = ReturnType<AppStore['getState']>
export type AppDispatch = ReturnType<AppStore['dispatch']>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    AppState,
    unknown,
    Action
>

export const wrapper = createWrapper<AppStore>(makeStore, {
    debug: false
})
